import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

import { CandidateTooltipComponent } from './candidate-tooltip.component';

@NgModule({
  imports: [
    CommonModule,
    MatDividerModule,
  ],
  declarations: [
    CandidateTooltipComponent,
  ],
  exports: [
    CandidateTooltipComponent,
  ],
})
export class CandidateTooltipModule {
}
